import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Login from "./pages/Login/Login";
import Home from "./pages/Landing/Home";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import Drivers from "./pages/Drivers/Drivers";
import Vehicles from "./pages/vehicles/Vehicles";
import Register from "./pages/Login/Register";
import AddVehicle from "./pages/vehicles/addVehicle";
import AddDriver from "./pages/Drivers/addDriver";
import Suppliers from "./pages/Suppliers/Suppliers";
import AddSupplier from "./pages/Suppliers/AddSupplier";
import VehicleAssignments from "./components/VehicleAssignments/VehicleAssignments";
import AddVehicleAssignment from "./components/VehicleAssignments/add_vehicleAssignments";
import Reports from "./pages/Reports/Reports";
import Chat from "./pages/Chat/Chat";
import { SidebarProvider } from "./contexts/SidebarContext";
import Settings from "./pages/Reports/Settings";
import StaffManagement from "./pages/staff/StaffManagement";
import AddStaff from "./pages/staff/AddStaff";
import FAQ from "./pages/Reports/FAQ";
import PrivacyPolicy from "./pages/Reports/PrivacyPolicy";
import TermsAndConditions from "./pages/Reports/TermsAndConditions";
import Unauthorized from "./pages/utils/Unauthorized";
import ProtectedRoute from "./pages/utils/Protectedroute";
import OutstandingSuppliers from "./pages/Suppliers/outstanding";
import RecycleBin from "./pages/RecycleBin/RecycleBin";
import MasterData from "./pages/masterData/masterdata";
import AuditLogViewer from "./pages/Auditlog/auditlog";
import FleetXLive from "./pages/FleetxLive/FleetxLive";
import VehicleDocumentsForm from "./pages/VehicleDocumentService/vehicle_document";
import VehicleDocumentsList from "./pages/VehicleDocumentService/VehicleDocumentsList";
import FleetByBranchManager from "./pages/FleetByBranch/Fleet_by_branch";
import { ConfirmProvider } from "./components/ConfirmDialog/ConfirmDialog";
import PWAUpdate from "./components/PWAUpdate";
import VehiclePerformance from "./pages/VehiclePerformance/VehiclePerformance";
import WhatsAppButton from "./pages/Whatsapp/Whatsapp";
import ChatbotWidget from "./pages/Chatbot/Chatbot";

import AbsentCabFollowUps from "./pages/FollowUps/AbsentCabFollowUps";
import OutstandingFollowUps from "./pages/FollowUps/OutstandingFollowUps";
import Followups from "./pages/FollowUps/Followups";
import GlobalSearch from "./components/Header/GlobalSearch";
import SupplierStatements from "./pages/SupplierPortal/SupplierStatements";
import SupplierLogin from "./pages/SupplierPortal/SupplierLogin";
import SupplierDashboard from "./pages/SupplierPortal/SupplierDashboard";
import SupplierVehicles from "./pages/SupplierPortal/SupplierVehicles";
import SupplierVehicleDocuments from "./pages/SupplierPortal/SupplierVehicleDocuments";

function GlobalWidgets() {
  const token = localStorage.getItem("token");
  const isSupplierPortal = window.location.pathname.startsWith("/supplier");

  if (!token) {
    return null;
  }

  if (isSupplierPortal) {
    return null;
  }

  return (
    <>
      <WhatsAppButton />
      <ChatbotWidget />
    </>
  );
}
function App() {
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        const token =
          localStorage.getItem("token");

        const publicPaths = [
          "/",
          "/login",
          "/register",
          "/unauthorized",
          "/faq",
          "/privacy-policy",
          "/terms-and-conditions",
        ];

        if (
          !token &&
          !publicPaths.includes(
            window.location.pathname
          )
        ) {
          window.location.replace(
            "/login"
          );
        }
      }
    };

    window.addEventListener(
      "pageshow",
      handlePageShow
    );

    return () => {
      window.removeEventListener(
        "pageshow",
        handlePageShow
      );
    };
  }, []);

  return (
    <ConfirmProvider>
      <SidebarProvider>
        <BrowserRouter>
          <PWAUpdate />

          <Routes>
            <Route
              path="/"
              element={<Home />}
            />

            <Route
              path="/login"
              element={<Login />}
            />

            <Route
              path="/register"
              element={<Register />}
            />

            <Route
              path="/unauthorized"
              element={<Unauthorized />}
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute module={null}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/drivers"
              element={
                <ProtectedRoute module="drivers">
                  <Drivers />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-driver"
              element={
                <ProtectedRoute module="drivers">
                  <AddDriver />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-driver/:id"
              element={
                <ProtectedRoute module="drivers">
                  <AddDriver />
                </ProtectedRoute>
              }
            />

            <Route
              path="/vehicles"
              element={
                <ProtectedRoute module="vehicles">
                  <Vehicles />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-vehicle"
              element={
                <ProtectedRoute module="vehicles">
                  <AddVehicle />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-vehicle/:id"
              element={
                <ProtectedRoute module="vehicles">
                  <AddVehicle />
                </ProtectedRoute>
              }
            />

            <Route
              path="/vehicle-performance"
              element={
                <ProtectedRoute module="vehicles">
                  <VehiclePerformance />
                </ProtectedRoute>
              }
            />

            <Route
              path="/suppliers"
              element={
                <ProtectedRoute module="suppliers">
                  <Suppliers />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-supplier"
              element={
                <ProtectedRoute module="suppliers">
                  <AddSupplier />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-supplier/:id"
              element={
                <ProtectedRoute module="suppliers">
                  <AddSupplier />
                </ProtectedRoute>
              }
            />

            <Route
              path="/suppliers/outstanding"
              element={
                <ProtectedRoute module="suppliers">
                  <OutstandingSuppliers />
                </ProtectedRoute>
              }
            />

            <Route
    path="/supplier/login"
    element={<SupplierLogin />}
/>

<Route
    path="/supplier/dashboard"
    element={<SupplierDashboard />}
/>

<Route
    path="/supplier/login"
    element={<SupplierLogin />}
/>

<Route
    path="/supplier/dashboard"
    element={<SupplierDashboard />}
/>

<Route
    path="/supplier/statements"
    element={<SupplierStatements />}
/>

<Route
  path="/supplier/vehicles"
  element={<SupplierVehicles />}
/>

<Route
  path="/supplier/vehicle-documents"
  element={<SupplierVehicleDocuments />}
/>

            <Route
              path="/vehicle-assignment"
              element={
                <ProtectedRoute module="assignments">
                  <VehicleAssignments />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-vehicle-assignment"
              element={
                <ProtectedRoute module="assignments">
                  <AddVehicleAssignment />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-vehicle-assignment/:id"
              element={
                <ProtectedRoute module="assignments">
                  <AddVehicleAssignment />
                </ProtectedRoute>
              }
            />

            <Route
              path="/messages"
              element={
                <ProtectedRoute module={null}>
                  <Chat />
                </ProtectedRoute>
              }
            />

            <Route
              path="/reports"
              element={
                <ProtectedRoute module="reports">
                  <Reports />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <ProtectedRoute module="settings">
                  <Settings />
                </ProtectedRoute>
              }
            />

            <Route
              path="/staff"
              element={
                <ProtectedRoute module="staff_management">
                  <StaffManagement />
                </ProtectedRoute>
              }
            />

            <Route
              path="/staff/add"
              element={
                <ProtectedRoute module="staff_management">
                  <AddStaff />
                </ProtectedRoute>
              }
            />

            <Route
              path="/staff/edit/:id"
              element={
                <ProtectedRoute module="staff_management">
                  <AddStaff />
                </ProtectedRoute>
              }
            />

            <Route
              path="/staff/delete"
              element={
                <ProtectedRoute module="staff_management">
                  <AddStaff />
                </ProtectedRoute>
              }
            />

            <Route
              path="/master-data"
              element={
                <ProtectedRoute module="master_data">
                  <MasterData />
                </ProtectedRoute>
              }
            />

            <Route
              path="/live-vehicles"
              element={
                <ProtectedRoute module="live_tracking">
                  <FleetXLive />
                </ProtectedRoute>
              }
            />

            <Route
              path="/fleet-by-branch"
              element={
                <ProtectedRoute module="branch_overview">
                  <FleetByBranchManager />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-vehicle-documents"
              element={
                <ProtectedRoute module="vehicle_documents">
                  <VehicleDocumentsForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-vehicle-documents/:vehicleId"
              element={
                <ProtectedRoute module="vehicle_documents">
                  <VehicleDocumentsForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/vehicle-documents"
              element={
                <ProtectedRoute module="vehicle_documents">
                  <VehicleDocumentsList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/followups"
              element={
                <ProtectedRoute module={null}>
                  <Followups />
                </ProtectedRoute>
              }
            />

            <Route
              path="/absent/followups"
              element={
                <ProtectedRoute module="absent followups">
                  <AbsentCabFollowUps />
                </ProtectedRoute>
              }
            />

            <Route
              path="/outstanding/followups"
              element={
                <ProtectedRoute module="outstanding followups">
                  <OutstandingFollowUps />
                </ProtectedRoute>
              }
            />

            <Route
              path="/audit-log"
              element={
                <ProtectedRoute module="audit-log">
                  <AuditLogViewer />
                </ProtectedRoute>
              }
            />

            <Route
              path="/recycle-bin"
              element={
                <ProtectedRoute module="Recycle Bin">
                  <RecycleBin />
                </ProtectedRoute>
              }
            />

            <Route
              path="/faq"
              element={<FAQ />}
            />



            <Route
              path="/global-search"
              element={<GlobalSearch />}
            />


            <Route
              path="/privacy-policy"
              element={<PrivacyPolicy />}
            />

            <Route
              path="/terms-and-conditions"
              element={
                <TermsAndConditions />
              }
            />

            <Route
              path="*"
              element={<Home />}
            />
          </Routes>

          <GlobalWidgets />
        </BrowserRouter>
      </SidebarProvider>
    </ConfirmProvider>
  );
}

export default App;



// cd ~/apps/tours-travels
// git restore package-lock.json
// git pull origin master
// npm install
// NODE_OPTIONS="--max-old-space-size=6144" npm run build
//  sudo cp -r build/* /var/www/html/
//  sudo systemctl restart nginx

// sudo cp -r build/* /var/www/srinivasafleet/


// sudo nginx -t
// sudo systemctl reload nginx